module.exports = __webpack_public_path__ + "static/media/DetailAc2.dfdef0a0.svg";